import script from "./CompanyConfig.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyConfig.vue?vue&type=script&setup=true&lang=js"

import "./CompanyConfig.vue?vue&type=style&index=0&id=c15ba88c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c15ba88c"]])

export default __exports__